import type {
	NormalizedWidgetListItem,
} from '@/store/types/widgetsListTypes';

function toStringValue(value: unknown): string {
	return typeof value === 'string' ? value.trim() : '';
}

function normalizeWidgetItem(item: Record<string, unknown>): NormalizedWidgetListItem | null {
	const testName = toStringValue(item.test_name ?? item.testName ?? item.name ?? item.title);
	const widgetKey = toStringValue(item.widget_key ?? item.widgetKey ?? item.key);
	const testUrl = toStringValue(item.test_url ?? item.testUrl ?? item.url ?? item.href);

	if (!testName || !widgetKey || !testUrl) {
		return null;
	}

	return { testName, widgetKey, testUrl };
}

/**
 * Разбор тела ответа списка виджетов.
 * Поддерживает массив в корне или в `data/list/items`.
 */
export function parseWidgetsListResponse(
	responseData: unknown,
): NormalizedWidgetListItem[] {
	if (Array.isArray(responseData)) {
		return responseData
			.filter((item): item is Record<string, unknown> => !!item && typeof item === 'object')
			.map((item) => normalizeWidgetItem(item))
			.filter((item): item is NormalizedWidgetListItem => item !== null);
	}

	if (!responseData || typeof responseData !== 'object') {
		return [];
	}

	const root = responseData as Record<string, unknown>;
	const rawList = root.data ?? root.list ?? root.items;

	if (!Array.isArray(rawList)) {
		return [];
	}

	return rawList
		.filter((item): item is Record<string, unknown> => !!item && typeof item === 'object')
		.map((item) => normalizeWidgetItem(item))
		.filter((item): item is NormalizedWidgetListItem => item !== null);
}
